import React, { JSX } from "react";
import { Container } from "./BasicLink.styled";
import { Typography, TypographyProps } from "@mui/material";

export type BasicLinkProps = {
  typographyProps?: TypographyProps;
} & React.ComponentProps<typeof Container>;

export const BasicLink: React.FC<BasicLinkProps> = (props): JSX.Element => {
  const { children, typographyProps, ...rest } = props;
  return (
    <Container {...rest}>
      <Typography variant={'v5'} {...typographyProps}>{children}</Typography>
    </Container>
  );
};
